"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.ExportIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M12 12C12.2667 11.7333 18.1111 5.88889 21 3M21 3L21 8M21 3H16", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    react_1.default.createElement("path", { d: "M10 3.16797H7C4.79086 3.16797 3 4.95883 3 7.16797V17.0013C3 19.2104 4.79086 21.0013 7 21.0013H17C19.2091 21.0013 21 19.2104 21 17.0013V14", strokeWidth: "2", strokeLinecap: "round" })), 'ExportIcon');
exports.default = exports.ExportIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwb3J0SWNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2ljb25zL0V4cG9ydEljb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQixtREFBZ0Q7QUFFbkMsUUFBQSxVQUFVLEdBQUcsSUFBQSw2QkFBWSxFQUNwQztJQUNFLHdDQUNFLENBQUMsRUFBQywrREFBK0QsRUFDakUsV0FBVyxFQUFDLEdBQUcsRUFDZixhQUFhLEVBQUMsT0FBTyxFQUNyQixjQUFjLEVBQUMsT0FBTyxHQUN0QjtJQUNGLHdDQUNFLENBQUMsRUFBQywySUFBMkksRUFDN0ksV0FBVyxFQUFDLEdBQUcsRUFDZixhQUFhLEVBQUMsT0FBTyxHQUNyQixDQUNELEVBQ0gsWUFBWSxDQUNiLENBQUM7QUFFRixrQkFBZSxrQkFBVSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/ExportIcon.js
// module id = 3542
// module chunks = 25